import { Component } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioChange } from '@angular/material/radio';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '../../../material.module';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core';
import { NgxEditorComponent, NgxEditorMenuComponent, Editor, Toolbar, NgxEditorModule } from 'ngx-editor';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NoteService } from '../notesofaccounts/note.service';
import moment from 'moment';
import { TextMaskDateDirective } from '../../../Directives/text-mask-date-directive.directive';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { NotesApiService } from '../notes/services/notes-api.service';
import { CharitiesService } from '../charities/services/charities.service';
import date from 'imask/esm/masked/date';
import { MatSelectChange } from '@angular/material/select';
import { CharityDetailsModal } from '../charities/addcharities/CharityDetailsModal';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { NotesDatashareService } from '../notes/services/notes-datashare.service';

@Component({
  selector: 'app-statementoftrustees',
  imports: [MaterialModule, TablerIconsModule, MatNativeDateModule,MatDatepickerModule, NgxEditorComponent, NgxEditorMenuComponent, CommonModule, FormsModule, ReactiveFormsModule, NgxEditorModule,  TextMaskDateDirective],
  templateUrl: './statementoftrustees.component.html',
  styleUrl: './statementoftrustees.component.scss',
  providers: [provideNativeDateAdapter(),{ provide: DateAdapter, useClass: CustomDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }, DatePipe],
})


export class StatementoftrusteesComponent {
  currentPeriod: any;
  trusteesList: any;
  charityID: any;
  CharityDetails: CharityDetailsModal[];
  CountryACT: any =''
    CountryName: string;
  MaindeFaultStatement: string;
  selectedReportOption: string = 'yes'; // default
  previousReportOption: string = 'yes'; // track last confirmed

  confirmed: boolean = false;
    BasicInformation: any;
    startDate: any;
  approvalDate: any;
  isdirty: any = false;
  constructor(private router: Router, private StatementofTrusteesService: NoteService, private datashare: NotesDatashareService, private _UsermanagementService: UsermanagementService,
    private apiservice: NotesApiService, private dataShareService: CharityDataShareServiceService, public Charities_Service: CharitiesService, private sharedService: CharityDataShareServiceService) {
 
    this.currentPeriod = localStorage.getItem('currentPeriod')
    this.charityID = localStorage.getItem('currentCharityID') != '' ? localStorage.getItem('currentCharityID') : 0
    this.GetUserAccess()
    this.createForm()
    this.Getbasicinformation()
    this.GetCharityDetails()


  }

  showContent = false;
  deFaultStatement: string

  editor: Editor;
  form: FormGroup;
  ngOnInit(): void {
    this.editor = new Editor();
   
 
    // this.GetStatementofTrustees()

    this.getTrustess()

    this.datashare.isdirty$.subscribe(value => {
      this.isdirty = value
    })
   // this.GetStatementofTrustees()
  }


  UserRoleAccess: RolesModel;
  GetUserAccess() {
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
      }
    });
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  backToTAR() {
    if (this.isDuirty()) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.form.markAsPristine()
          this.isdirty = false
          this.datashare.setisdirty(false);
          this.router.navigate(['trusteeannualreport']);
        }
        else {
          return

        }
      })
    } 
    else {
      this.form.markAsPristine()
      this.router.navigate(['trusteeannualreport']);
    }

  }
  setVisibility(event: MatRadioChange) {
    debugger
   // event.value='yes'
    if (!this.showContent) {
      this.showContent = !this.showContent;
      this.form.controls['includeTAR'].setValue(this.showContent)
      this.form.controls['trusteeStatement'].setValue(this.deFaultStatement)
    //  this.GetStatementofTrustees()
    }
    else {
     // if (!this.isDuirty()) {
        this.showContent = !this.showContent;
        this.form.controls['includeTAR'].setValue(this.showContent)
        this.form.controls['trusteeStatement'].setValue(this.deFaultStatement)
        ///this.createForm()
      
      //} else {
       
      //    Swal.fire({
      //      html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Do you  want change. <br> Data entered will not be saved.</p>',
      //      iconHtml: '<span class="fa fa-question"></span>',
      //      confirmButtonText: "Leave",
      //      showCancelButton: true,
      //      cancelButtonText: "Stay",
      //      allowOutsideClick: false
      //    }).then((result) => {
      //      if (result.value) {
      //        this.showContent = !this.showContent;
      //        this.form.controls['includeTAR'].setValue(this.showContent)
      //        this.form.controls['trusteeStatement'].setValue(this.deFaultStatement)
      //      }
      //      else {
      //        return
      //      }
      //    })
      //  }
       
      
    }
   // event.value = this.showContent==true?'yes':'no'
  }
  setVisibility1(event: MatRadioChange): void {
    const newValue = event.value;

    debugger
    if (newValue === this.previousReportOption) return;

    Swal.fire({
      html: `<h5 class="f-s-16 f-w-600 text-black">Are you sure?</h5>
           <p class="f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px">
             Do you want to change? <br> Data entered will not be saved.
           </p>`,
      iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      confirmButtonText: 'Leave',
      showCancelButton: true,
      cancelButtonText: 'Stay',
      allowOutsideClick: false,
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        this.selectedReportOption = newValue;
        this.previousReportOption = newValue;

        this.showContent = newValue === 'yes';
        this.form.controls['includeTAR'].setValue(this.showContent);
        this.form.controls['trusteeStatement'].setValue(this.deFaultStatement);
      } else {
        // Revert radio selection
        this.selectedReportOption = this.previousReportOption;
      }
    });
  }

  CurrentDate_Validate(Event?: any) {
    debugger
    const SelectedDate = moment(Event.target.value, 'DD/MM/YYYY', true);
    var CurApStartDate = moment(this.BasicInformation[0].current_AP_Start_Date)
    //this.BasicInformation[0].current_AP_End_Date
    //var _2015 = moment('01-01-2015')
    const isValidDate = SelectedDate.isValid();
    //var SelecteDate = new Date(Event.target.value)
    var nextstartdate = moment()
    const isBeforeThreshold = moment(Event.target.value, 'DD/MM/YYYY').isBefore(moment('01/01/1753', 'DD/MM/YYYY'));
    if (!isValidDate) {
      this.form.get('approvalDate')?.setErrors({ InvalidDate: true })
    }
    else if (SelectedDate > nextstartdate && !isBeforeThreshold) {
      this.form.get('approvalDate')?.setErrors({ IsAfterToday: true })
    }
    else if (SelectedDate < CurApStartDate && !isBeforeThreshold) {
      this.form.get('approvalDate')?.setErrors({ IsBeforeAP: true })
    }
  
  }

  getTrustess() {

    this.Charities_Service.GetTrusteeDetails(this.charityID).subscribe((data: any) => {
      debugger
      if (data.entity != null) {
        this.trusteesList = data.entity
      }
    })
  }
  isDuirty():any {
    if (this.form.dirty) {
      return true
    } else {
      return false
    }

  }
  //html = '';
  validateTruste(event: any) {debugger
    if (event.target.value == null || event.target.value == "") {
      this.form.get('trusteeID')?.setErrors({ required: true })
      this.form.get('trusteeID')?.markAsTouched()
    } else {
      this.form.get('trusteeID')?.setErrors(null)
      this.form.get('trusteeID')?.markAsPristine()
    }

  }
  vldtrusteedateofapp(event: any) {
    debugger
    if ((event.target.value == null || event.target.value == "") && !(+this.form.get('approvalDate')?.getRawValue()>0)) {
      this.form.get('approvalDate')?.setErrors({ required: true })
      this.form.get('approvalDate')?.markAsTouched()
    } else {
      this.form.get('approvalDate')?.setErrors(null)
      this.CurrentDate_Validate(event)

    }
 
  }
  onTrusteeChange(event: MatSelectChange,type?:any): void {debugger
    const selectedTrusteeId = event.value;
    var selectedTrustee: any
    if ((selectedTrusteeId && type =='selected')) {
      this.form.get('trusteeID')?.setErrors(null)
      selectedTrustee = this.trusteesList.find((t: any) => t.trustee_Id === selectedTrusteeId);
      this.form.patchValue({
        trusteeName: selectedTrustee.name
      });
    } else {
      if (this.form.get('trusteeID')?.getRawValue()==0) {
        this.form.get('trusteeID')?.setErrors({ required: true })
      }
    }

  }
  createForm() {
    this.form = new FormGroup({
      trusteeStatementID: new FormControl(0),
      trusteeStatement: new FormControl(this.deFaultStatement, [Validators.required]),
      trusteeName: new FormControl(''),
      trusteeID: new FormControl(0, [Validators.required]),
      approvalDate: new FormControl(null),
      financialPeriodsID: new FormControl(+this.currentPeriod),
      charityID: new FormControl(+this.charityID),
      includeTAR: new FormControl(this.showContent)
    });

    this.form.get('trusteeStatement')?.valueChanges.subscribe(value => {
    //  alert('')
      debugger
      const plainText = value?.replace(/<[^>]*>/g, '') || '';
     // const plainText = value
      if (plainText.length > 2500) {
        const trimmedText = plainText.substring(0, 2500);
        const safeHtml = trimmedText;
        this.form.get('trusteeStatement')?.setValue(safeHtml, { emitEvent: false });
      }
    });

    //this.form.get('trusteeStatement')?.valueChanges.subscribe(value => {debugger
    //  const limitedHtml = this.limitHtmlContent(value, 2500);
    //  this.form.get('trusteeStatement')?.setValue(limitedHtml, { emitEvent: false });
    //  this.MarkDirty()
    //});
  }

  limitHtmlContent(html: string, maxLength: number = 2500): string {
    const div = document.createElement('div');
    div.innerHTML = html;

    let charCount = 0;
    const walker = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null);
    const nodesToRemove: Node[] = [];

    while (walker.nextNode()) {
      const node = walker.currentNode as Text;
      const remaining = maxLength - charCount;

      if (remaining <= 0) {
        nodesToRemove.push(node);
      } else if (node.nodeValue!.length > remaining) {
        node.nodeValue = node.nodeValue!.substring(0, remaining);
        charCount = maxLength;
      } else {
        charCount += node.nodeValue!.length;
      }
    }

    // Remove extra text nodes
    nodesToRemove.forEach(node => node.parentNode?.removeChild(node));

    // Remove empty elements left behind
    const cleanEmptyElements = (element: HTMLElement) => {
      Array.from(element.children).forEach(child => {
        cleanEmptyElements(child as HTMLElement);
        if (
          child.childNodes.length === 0 ||
          (child.childNodes.length === 1 && child.childNodes[0].nodeType === Node.TEXT_NODE && !(child.textContent || '').trim())
        ) {
          child.remove();
        }
      });
    };

    cleanEmptyElements(div);

    return div.innerHTML;
  }


  GetCharityDetails() {
    this.Charities_Service.EditCharityDetails(this.charityID).subscribe((data: CharityDetailsModal[]) => {
      debugger
      this.CharityDetails = data

        //< mat - option value = "england_wales" > England and Wales < /mat-option>
        //  < mat - option value = "scotland" > Scotland < /mat-option>
        //    < mat - option value = "northern_ireland" > Northern Ireland < /mat-option>

      if (data[0].charity_Type == 'Unincorporated Charity') {
        if (this.CharityDetails[0].jurisdiction_Charity == "england_wales") {
          this.CountryACT = `the Charity (Accounts and Reports) Regulations 2008`
          this.CountryName ='England and Wales'
        }

        else if (this.CharityDetails[0].jurisdiction_Charity == "scotland") {
          this.CountryACT = `the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006`
          this.CountryName = 'Scotland'
        }
        else {
          this.CountryACT = `The Charities (Accounts and Reports) Regulations (Northern Ireland) 2015]`
          this.CountryName = 'Northern Ireland'
        }

        this.MaindeFaultStatement = `<p>The trustees are responsible for preparing the Trustees' Annual Report and the financial statements in accordance with applicable law and United Kingdom Accounting Standards (United Kingdom Generally Accepted Accounting Practice).</p>

        <p>The law applicable to charities in ${this.CountryName } requires the trustees to prepare financial statements for each financial year which give a true and fair view of the state of affairs of the charity and of the incoming resources and application of resources of the charity for that period. In preparing these financial statements, the trustees are required to:</p>

         <ul>
            <li>select suitable accounting policies and apply them consistently;</li>
            <li>observe the methods and principles in the Charities SORP;</li>
            <li>make judgments and estimates that are reasonable and prudent;</li>
            <li>state whether applicable accounting standards have been followed, subject to any departures disclosed and explained in the financial statements; and</li>
            <li>prepare the accounts on a going concern basis unless it is inappropriate to presume that the charity will continue in business.</li>
         </ul>
        <p>The trustees are responsible for maintaining proper accounting records which disclose with reasonable accuracy at any time the financial position of the charity and to enable them to ensure that the accounts comply with the Charities Act 2011 ${this.CountryACT} and the provisions of the trust deed. They are also responsible for safeguarding the assets of the charity and hence for taking reasonable steps for the prevention and detection of fraud and other irregularities.`
      }
      else {

        if (this.CharityDetails[0].jurisdiction_Charity == "england_wales")
          this.CountryACT = `the accounts comply with the Companies Act 2006`

        else if (this.CharityDetails[0].jurisdiction_Charity == "scotland")
          this.CountryACT = `the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006]`
        else
          this.CountryACT = ``

        this.MaindeFaultStatement = `<p>The trustees (who are also directors of ${this.CharityDetails[0].charity_Name} for the purposes of company law) are responsible for preparing the Trustees' Annual Report and the financial statements in accordance with applicable law and United Kingdom Accounting Standards (United Kingdom Generally Accepted Accounting Practice).</p>

        <p>Company law requires the trustees to prepare financial statements for each financial year. Under company law the trustees must not approve the financial statements unless they are satisfied that they give a true and fair view of the state of affairs of the charitable company and of the incoming resources and application of resources, including the income and expenditure, of the charitable company for that period. In preparing these financial statements, the trustees are required to:</p>

          <ul>
            <li>select suitable accounting policies and apply them consistently;</li>
            <li>observe the methods and principles in the Charities SORP;</li>
            <li>make judgments and estimates that are reasonable and prudent;</li>
            <li>state whether applicable UK accounting standards have been followed, subject to any departures disclosed and explained in the financial statements; and</li>
            <li>prepare the accounts on a going concern basis unless it is inappropriate to presume that the charity will continue in business.</li>
         </ul>
        <p>The trustees are responsible for maintaining proper accounting records which disclose with reasonable accuracy at any time the financial position of the charitable company and to enable them to ensure that ${this.CountryACT}. They are also responsible for safeguarding the assets of the charitable company and hence for taking reasonable steps for the prevention and detection of fraud and other irregularities.</p>`;

      }
      this.deFaultStatement = this.MaindeFaultStatement
      this.GetStatementofTrustees()
    })}
  SetDefault() {
    debugger
    this.deFaultStatement = this.MaindeFaultStatement
    this.form.controls['trusteeStatement'].setValue(this.deFaultStatement)
  }
  DbDateConverter(ControllerDate: any) {
    if (ControllerDate) {
      const momentDate = moment(ControllerDate);
      const localMidnight = momentDate.startOf('day');
      const formattedDate = localMidnight.format('YYYY-MM-DDTHH:mm:ss.SS[Z]');
      console.log(formattedDate);
      return formattedDate.toString();
    } else {
      return null;
    }
  }
  backToCharityOverView() {
    debugger

    if (this.isDuirty()) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.form.markAsPristine()
          this.isdirty = false
          this.datashare.setisdirty(false);
          localStorage.setItem('isFromBasicInfo', 'true')
          this.router.navigate(['/charity']);
        }
        else {
          // this.spinner.hide()
          return

        }
      })
    }
    else {
      this.form.markAsPristine()
      localStorage.setItem('isFromBasicInfo', 'true')
      this.router.navigate(['/charity']);
    }
  }
  save(): void {
    debugger

    if (this.form.controls['trusteeStatement'].value == '<p></p>' || this.form.controls['trusteeStatement'].value == "") {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Statement of Trustees’ Responsibility is required</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "OK",
        showCancelButton: false,
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          return true
        } else {
          return false
        }
      })

    } else {
      const financialYear = localStorage.getItem('financial_Year');
      if (financialYear != null) {
        this.startDate = financialYear.split(' To ')[0].trim();
        this.startDate = moment(this.startDate, 'DD MMM YYYY');
      }

      this.approvalDate = this.form.controls['approvalDate'].value ? moment(this.form.controls['approvalDate'].value) : null;
      this.form.markAllAsTouched()
      if (this.showContent == false) {
        this.createForm()
        this.form.controls['approvalDate'].setErrors(null)
        this.form.controls['trusteeID'].setErrors(null)
        this.form.controls['trusteeName'].setErrors(null)
      } else {
        const today = moment().startOf('day');
        //this.form.controls['approvalDate'].getRawValue() == null ? this.form.controls['approvalDate'].setErrors({ required: true }) : this.form.controls['approvalDate'].setErrors(null)
        this.form.controls['approvalDate'].getRawValue() == null && !this.form.get('approvalDate')?.errors ? this.form.controls['approvalDate'].setErrors({ required: true }) : !this.form.get('approvalDate')?.errors ? this.form.controls['approvalDate'].setErrors(null) : ''
        if (this.form.controls['approvalDate'].getRawValue() != null) {
          this.approvalDate.isBefore(this.startDate, 'day') || this.approvalDate.isAfter(today, 'day') ? this.form.get('approvalDate')?.setErrors({ IsBeforeAP: true }) : this.form.controls['approvalDate'].setErrors(null)
        }
          this.form.controls['trusteeID'].getRawValue() == 0 ? this.form.controls['trusteeID'].setErrors({ required: true }) : this.form.controls['trusteeID'].setErrors(null)
        //  this.form.controls['trusteeID'].setErrors({ required: true })
        this.form.controls['trusteeName'].setErrors(null)
      }
      if (this.form.valid) {
        // if (this.showContent == false) { this.createForm() }
        this.form.controls['approvalDate'].setValue(this.DbDateConverter(this.form.controls['approvalDate'].getRawValue()))

        var value = this.form.getRawValue()
        this.StatementofTrusteesService.SaveStatementofTrustees(value).subscribe((Respone: any) => {
          debugger
          this.form.markAsPristine();
          //   this.GetStatementofTrustees()
          //this.router.navigate(['final-accounts']);

          if (this.BasicInformation[0].report_Type == 'Independent Examiner') {
            this.router.navigate(['independentexaminerreport']);
          } else {
            this.router.navigate(['audit-report']);
          }
        })
      } else if (this.form.controls['trusteeStatement'].value == '<p></p>' || this.form.controls['trusteeStatement'].value == "") {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Statement of Trustees’ Responsibility is required</p>',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            return true
          } else {
            return false
          }
        })


      }
    }
  }
  GetStatementofTrustees(): void {
    debugger
    this.StatementofTrusteesService.GetStatementofTrustees(this.currentPeriod).subscribe((Respone: any) => {
      debugger
      if (Respone.entity) {
        this.deFaultStatement = Respone.entity[0].trusteeStatement
        this.form.patchValue(Respone.entity[0])
        this.form.controls['approvalDate'].setValue(Respone.entity[0]?.approvalDate!=null?new Date(Respone.entity[0]?.approvalDate):null)
        this.showContent = Respone.entity[0]?.includeTAR

      } else {
        this.createForm()
      }
    })
  }
  MarkDirty() {
    debugger
    this.datashare.setisdirty(true)
    this.isdirty = true
  }
  CanDeactivate() {
    debugger
    this.sharedService.updateisLoadingResults(false)

    if (this.isDuirty()) {
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.isdirty = false
          this.datashare.setisdirty(false);
          return true
        } else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return false
        }
      })
    } else {
      return true
    }
  }
  Getbasicinformation() {
    debugger
  
    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      this.BasicInformation = data
    })
  }
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
}
